import { createContext } from 'react';

/** @deprecated This can and should be removed! */

const ConfigContext = /*#__PURE__*/createContext({
  config: null
});

export { ConfigContext };
//# sourceMappingURL=config.js.map
